// Stub: expo-status-bar — no-op on web/desktop (browser controls the status bar)
import React from 'react';

export const StatusBar = () => null;
export const setStatusBarStyle                          = () => {};
export const setStatusBarHidden                         = () => {};
export const setStatusBarNetworkActivityIndicatorVisible = () => {};
export const setStatusBarBackgroundColor                = () => {};
export const setStatusBarTranslucent                    = () => {};
export const setStatusBarAnimation                      = () => {};

// TypeScript types stripped by babel — provide empty-object placeholders so
// that re-export chains don't produce "no exports" webpack warnings.
export const StatusBarStyle     = {};
export const StatusBarAnimation = {};

export default {
  StatusBar,
  setStatusBarStyle, setStatusBarHidden,
  setStatusBarNetworkActivityIndicatorVisible,
  setStatusBarBackgroundColor, setStatusBarTranslucent, setStatusBarAnimation,
  StatusBarStyle, StatusBarAnimation,
};
